<template>
    <div>
        <UpperBar v-on:add="addUser" v-bind:newRecord="newUser" v-bind:addButton="addButton" v-bind:placeholder="placeholder" v-on:searched-data="setSearchBar"/>
        <div v-show="newUser" class="template">
            <p><span>Nazwisko: </span><b-input v-model="newLastName"></b-input></p>
            <p><span>Imię: </span><b-input v-model="newFirstName"></b-input></p>
            <p><span>Numer telefonu: </span><b-input v-model="newPhoneNumber"></b-input></p>
            <p><span>Adres email: </span><b-input v-model="newEmailAddress"></b-input></p>
            <div class="showGroups"><span>Grupy: </span>
                <button v-for="groupItem in groups" :key="groupItem._id" v-bind:class="[newGroup.includes(groupItem.name) ? correct : negative, 'groupButton']"
                v-on:click="toggleAddGroup(groupItem.name)">
                    {{groupItem.name}}
                </button>
            </div>
            <div class="buttons">
                <b-button v-on:click="sendUser()">Zatwierdź</b-button>
                <b-button v-on:click="cancelAdding()">Anuluj</b-button>
            </div>
        </div>
        <b-button v-on:click="showAll" class="buttonShow">{{showUsersButtonName}}</b-button>
        <div>
            <div v-for="item in users" :key="item._id" class="usersList">
                <b-button v-show="userId != item._id && (item.lastName.toLowerCase().includes(searchBar.toLowerCase())
                || item.firstName.toLowerCase().includes(searchBar.toLowerCase())
                || item.phoneNumber.toString().includes(searchBar))
                || item.mailAddress.toLowerCase().includes(searchBar.toLowerCase())" v-if="(searchBar && searchBar.length > 2) || showAllUsers == true" 
                class="button" v-on:click="showUser(item._id)">{{item.lastName}} {{item.firstName}}</b-button>
                <div v-show="userId === item._id && editedUser != item._id" class="template">
                    <p><span>Nazwisko: </span>{{item.lastName}}</p>
                    <p><span>Imię: </span>{{item.firstName}}</p>
                    <p><span>Numer telefonu: </span>{{item.phoneNumber}}</p>
                    <p><span>Adres email: </span>{{item.mailAddress}}</p>
                    <div class="showGroups"><span>Grupy:</span>
                        <p v-for="groupItem in item.groups" :key="groupItem._id">
                        {{groupItem}}
                        </p>
                    </div>
                    <div class="buttons" v-show="confirmation != item._id">
                        <b-button v-on:click="editUser(item._id, item.lastName, item.firstName, item.phoneNumber, item.mailAddress, item.groups)">Edytuj</b-button>
                        <b-button v-on:click="closeUser()">Zamknij</b-button>
                        <b-button v-on:click="delUser(item._id)">Usuń</b-button>
                    </div>
                    <div v-if="confirmation === item._id" class="confirm">Czy napewno chcesz usunąć ten komunikat ?
                        <b-button class="button" v-on:click="confirmDelUser(item._id)">Tak</b-button>
                        <b-button class="button" v-on:click="cancelDelUser()">Nie</b-button>
                    </div>
                </div>
                <div v-if="editedUser == item._id" class="template">
                    <p><span>Nazwisko: </span><b-input v-model="lastNameToEdit"></b-input></p>
                    <p><span>Imię: </span><b-input v-model="firstNameToEdit"></b-input></p>
                    <p><span>Numer telefonu: </span><b-input v-model="phoneNumberToEdit"></b-input></p>
                    <p><span>Adres email: </span><b-input v-model="emailAddressToEdit"></b-input></p>
                    <div class="showGroups"><span>Grupy: </span>
                        <button v-for="groupItem in groups" :key="groupItem._id" v-bind:class="[item.groups ? (item.groups.includes(groupItem.name) ? correct : negative) : negative, 'groupButton']"
                        v-on:click="toggleGroup(item._id, groupItem.name)">
                            {{groupItem.name}}
                        </button>
                    </div>
                    <div class="buttons">
                        <b-button v-on:click="applyChanges(item._id, lastNameToEdit, firstNameToEdit, phoneNumberToEdit, emailAddressToEdit, item.groups, item.author)">Zatwierdź</b-button>
                        <b-button v-on:click="cancelChanges(item._id)">Anuluj</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
import UpperBar from '../ViewElements/UpperBar';
export default {
    name: 'UsersCMS',
    methods: {
        editUser: async function(id, lastName, firstName, phoneNumber, mailAddress, groups){
            await this.showGroups();
            this.editedUser = id;
            this.lastNameToEdit = lastName;
            this.firstNameToEdit = firstName;
            this.phoneNumberToEdit = phoneNumber;
            this.emailAddressToEdit = mailAddress;
            if(groups){
                this.groupsBackup = groups.slice();
            }
        },
        showUser: function(userId){
            this.userId = userId;
            this.newUser = false;
            this.editedUser = '';
        },
        closeUser: function(){
            this.userId = '';
            this.confirmation = '';
        },
        delUser: async function(id){
            this.confirmation = id;
        },
        confirmDelUser: async function(id){
            await axios
                .delete(`${path}users/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('message deleted')
            this.$emit('shutUsers', 'Usunięto pracownika');
        },
        cancelDelUser: function() {
            this.confirmation = '';
        },
        cancelChanges: function(id){
            this.editedUser = '';
            for(let item of this.users){
                if(item._id === id){
                    item.groups = this.groupsBackup;
                }
            }
        },
        applyChanges: function(id, lastName, firstName, phoneNumber, mailAddress, groups, author){
            this.editedUser = '';
            console.log('author: ', author)
            const payload = {
               lastName: lastName,
               firstName: firstName,
               phoneNumber: phoneNumber,
               mailAddress: mailAddress,
               groups: groups,
               author: author,
            } 
            axios
                .put(`${path}users/${id}`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.changeUser(id);
        },
        changeUser: function(id){
            for(let item of this.users){
                if(item._id === id){
                    item.lastName = this.lastNameToEdit;
                    item.firstName = this.firstNameToEdit;
                    item.phoneNumber = this.phoneNumberToEdit;
                    item.mailAddress = this.emailAddressToEdit;
                }
            }
        },
        addUser: async function(){
            await this.showGroups();
            this.newUser = true;
            this.userId = '';
            this.editedUser = '';
        },
        cancelAdding: function(){
            this.newUser = false;
            this.newLastName = '';
            this.newFirstName = '';
            this.newPhoneNumber = '';
            this.newEmailAddress = '';
            this.groups = '';
        },
        sendUser: async function(){
            const payload = {
                firstName: this.newFirstName,
                lastName: this.newLastName,
                phoneNumber: this.newPhoneNumber,
                mailAddress: this.newEmailAddress,
                groups: this.newGroup,
                author: this.userData.name
            } 
            await axios
                .post(`${path}users`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.newUser = false;
            this.$emit('shutUsers', 'Dodano nowego pracownika');
        },
        showGroups: async function(){
            await axios
            .get(`${path}groups`)
            .then(response => (
                this.groups = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
        },
        toggleGroup: async function(id, name){
            for(let item of this.users){
                if(item._id === id && !item.groups){
                    item.groups.push(name);
                }   else if(item._id === id && !item.groups.includes(name)){
                    item.groups.push(name);
                }   else if(item._id === id && item.groups.includes(name)){
                    item.groups = item.groups.filter(x => x !== name)
                }
            }
        },
        toggleAddGroup: async function(name){
            if(this.newGroup.includes(name)){
                this.newGroup = this.newGroup.filter(x => x !== name)
            }   else if(!this.newGroup.includes(name)){
                await this.newGroup.push(name);
            }
        },
        setSearchBar: function(searchData){
            this.searchBar = searchData;
        },
        showAll: function(){
            this.showAllUsers = !this.showAllUsers;
            if(this.showUsersButtonName === 'Pokaż wszystkich pracowników'){
                this.showUsersButtonName = 'Ukryj wszystkich pracowników';
            } else {
                this.showUsersButtonName = 'Pokaż wszystkich pracowników';
            }
        }
    },
    components: {
        UpperBar,
    },
    props: ['dbUsers', 'userData'],
    data: function(){
        return{
            users: this.dbUsers,
            groupsBackup: '',
            userId: '',
            confirmation: '',
            editedUser: '',
            lastNameToEdit: '',
            firstNameToEdit: '',
            phoneNumberToEdit: '',
            emailAddressToEdit: '',
            groupsToEdit: '',
            newUser: false,
            newFirstName: '',
            newLastName: '',
            newPhoneNumber: '',
            newEmailAddress: '',
            newGroup: [],
            groups: '',
            correct: 'correct',
            negative: 'negative',
            searchBar: '',
            addButton: 'Dodaj Pracownika',
            placeholder: 'min. 3 znaki',
            showAllUsers: false,
            showUsersButtonName: 'Pokaż wszystkich pracowników' 
        }
    }
}
</script>
<style lang="scss" scoped>
    .usersList {
        display: inline;
        .button {
            margin: 10px;
            background-color: white;
            color: black;
        }
    }
    .upperPanel {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 90%;
        margin: 0 auto;
        .addButton {
        background-color: green;
        margin: 10px;
        }
        .icon {
            background-color: blue;
        }
    }
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        width: 90%;
        margin: 0 auto;
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 5px;
        }
        span {
            font-weight: bold;
        }
        p{
            padding: 0;
            margin: 0;
        }
        .showGroups {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 5px;
            overflow: auto;
            max-height: 300px;
            p{
                margin: 0 5px;
                padding: 0 5px;
                border: solid;
                border-width: 1px;
            }
            button {
                margin: 5px;
                border: none;
                font-family: 'Source Code Pro', monospace;
            }
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
    .correct {
        background-color: green;
    }
    .negative {
        background-color: red;
    }
    .groupButton {
        color: white;
    }
    .buttonShow {
        background-color: green;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(101, 168, 0);
        }
        &:focus{
            background-color: green;
            border: none;
            box-shadow: none;
        }
    }
</style>